<!--
 * @Author: natsu
 * @Date: 2020-09-02 16:51:59
 * @LastEditors: natsu
 * @LastEditTime: 2020-12-23 10:07:30
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/echarts.png" /></div>
      <p>Echarts</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/echarts/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "5.1.2",
          linkList: [ur + "5.1.2/echarts.js", ur + "5.1.2/echarts.min.js"]
        },
        {
          label: "5.0.0",
          linkList: [ur + "5.0.0/echarts.js", ur + "5.0.0/echarts.min.js"]
        },
        {
          label: "4.8.0",
          linkList: [ur + "4.8.0/echarts.min.js", ur + "4.8.0/bmap.min.js"]
        },
        {
          label: "4.2.1",
          linkList: [
            ur + "4.2.1/echarts.js",
            ur + "4.2.1/echarts.min.js",
            ur + "4.2.1/china.js",
            ur + "4.2.1/china.min.js"
          ]
        },
        {
          label: "4.1.0",
          linkList: [ur + "4.1.0/echarts.js", ur + "4.1.0/echarts.min.js"]
        },
        {
          label: "4.0.4",
          linkList: [ur + "4.0.4/echarts.js", ur + "4.0.4/echarts.min.js"]
        },
        {
          label: "4.0.3",
          linkList: [ur + "4.0.3/echarts.js", ur + "4.0.3/echarts.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListEcharts.vue